import { FETCH_ASSIGNED_CREATIVES } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchAssignedCreativesService } from "../../services/dcm/creatives";
import { setAuthError } from "../app/global";

const beginFetchAssignedCreatives = (
  campaignId,
  creativeTypes,
  sizes,
  advertiserId
) => ({
  type: FETCH_ASSIGNED_CREATIVES,
  status: PENDING,
  campaignId,
  creativeTypes,
  sizes,
  advertiserId
});

const successAssignedCreatives = creatives => ({
  type: FETCH_ASSIGNED_CREATIVES,
  status: SUCCESS,
  data: creatives
});

const failureAssignedCreatives = err => ({
  type: FETCH_ASSIGNED_CREATIVES,
  status: FAILURE,
  err
});

export const fetchAssignedCreatives = (
  campaignId,
  creativeTypes,
  sizes,
  advertiserId
) => {
  return async dispatch => {
    dispatch(
      beginFetchAssignedCreatives(
        campaignId,
        creativeTypes,
        sizes,
        advertiserId
      )
    );

    let assignedCreatives;

    try {
      assignedCreatives = await fetchAssignedCreativesService(
        campaignId,
        creativeTypes,
        sizes,
        advertiserId
      );

      dispatch(successAssignedCreatives(assignedCreatives));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      dispatch(failureAssignedCreatives(e));
    }
  };
};

export const clearAssignedCreatives = () => {
  return async dispatch => {
    dispatch(successAssignedCreatives([]));
  }
}
